enum AttachmentDialogFields {
	FILE = "file",
	TEXT = "text",
	LOCKED = "locked",
	ICON = "icon",
	COLOR = "color",
	OPACITY = "opacity",
}

export default AttachmentDialogFields;